import { paletteDark, paletteLight } from '@finam/web-ui-kit';
export var createThemePaletteBlack = function createThemePaletteBlack() {
  return paletteDark;
};
export var createThemePaletteWhite = function createThemePaletteWhite() {
  return paletteLight;
};